import(/* webpackMode: "eager" */ "/vercel/path0/src/app/stats/page.tsx");
